<template>
  <div class="wrapper">
    <div class="page-head2 page-header-mini" :style="{ marginBottom: `${logo_altura}px` }"></div>

    <div class="container" style="padding-top: 30px; padding-bottom: 60px;">
      <div class="row">
        <div class="col-md-10 ml-auto mr-auto">

          <h2 style="font-weight: 800; color: #0045c4;">Completa tu contratación</h2>
          <p class="text-muted">Rellena los datos que faltan y procede al pago seguro.</p>
          <hr>

          <!-- Estado de carga -->
          <div v-if="!datosCargados && !errorCarga" style="padding: 20px 0; color: #888;">
            Cargando información...
          </div>
          <div v-if="errorCarga" style="padding: 20px 0; color: #f00;">
            No se pudo cargar la información del espacio. Por favor contacta con nosotros.
          </div>

          <!-- Resumen del box -->
          <div class="row" v-if="datosCargados && precioCargado">
            <div class="col-sm-6 col-md-5">
              <card>
                <h4 class="card-title">Tu espacio seleccionado</h4>
                <p class="card-text" style="font-size: 14px;">
                  <b>Referencia:</b> {{ contrato.ref }}<br>
                  <b>Periodo:</b> {{ fch_dsd_web }} — {{ fch_hst_web }}<br>
                </p>
                <p class="card-text text-right" style="font-size: 14px;">
                  Fianza: <b>{{ imp_dep }}€</b><br>
                  Mensualidad: <b>{{ pvp_men }}€</b><br>
                  Total primer cobro: <b>{{ pvp_web }}€</b>
                </p>
              </card>
            </div>
          </div>

          <hr v-if="datosCargados">

          <!-- Formulario datos personales -->
          <div v-if="datosCargados">
            <h4 style="font-weight: 700;">Tus datos personales</h4>
            <div class="row" style="padding-top: 10px;">

              <div class="col-md-4 pl-2">
                <label>Nombre *</label>
                <fg-input v-model="contrato.nombre"
                          :error="errores.nombre"
                          @input="valida('nombre')"/>
              </div>
              <div class="col-md-4 pl-2">
                <label>Primer apellido *</label>
                <fg-input v-model="contrato.apellido1"
                          :error="errores.apellido1"
                          @input="valida('apellido1')"/>
              </div>
              <div class="col-md-4 pl-2">
                <label>Segundo apellido</label>
                <fg-input v-model="contrato.apellido2"/>
              </div>

              <div class="col-md-3 pl-2">
                <label>NIF / NIE *</label>
                <fg-input v-model="contrato.nif"
                          :error="errores.nif"
                          @input="valida('nif')"/>
              </div>
              <div class="col-md-3 pl-2">
                <label>Teléfono *</label>
                <fg-input v-model="contrato.telefono"
                          :error="errores.telefono"
                          @input="valida('telefono')"/>
              </div>
              <div class="col-md-6 pl-2">
                <label>Email *</label>
                <fg-input v-model="contrato.email"
                          :error="errores.email"
                          @input="valida('email')"
                          @blur="contrato.email = contrato.email.toLowerCase()"/>
              </div>

              <div class="col-md-8 pl-2">
                <label>Dirección *</label>
                <fg-input v-model="contrato.direccion"
                          :error="errores.direccion"
                          @input="valida('direccion')"/>
              </div>
              <div class="col-md-4 pl-2">
                <label>Código Postal *</label>
                <fg-input v-model="contrato.cp"
                          :error="errores.cp"
                          @input="valida('cp')"/>
              </div>
              <div class="col-md-6 pl-2">
                <label>Localidad *</label>
                <fg-input v-model="contrato.localidad"
                          :error="errores.localidad"
                          @input="valida('localidad')"/>
              </div>
              <div class="col-md-6 pl-2">
                <label>Provincia</label>
                <fg-input v-model="contrato.provincia"/>
              </div>

            </div>

            <hr>

            <!-- Acepto términos -->
            <div style="padding: 10px 0 15px 0;">
              <n-checkbox v-model="autorizo">
                Acepto los <router-link to="/terminos">términos del contrato</router-link>
                y la <router-link to="/cookies">Política de Privacidad</router-link>.
              </n-checkbox>
            </div>

            <!-- Autorizar recurrente -->
            <div style="padding-bottom: 25px;" v-if="pagopasarela">
              <n-checkbox v-model="pagorec">
                Autorizar cargos mensuales recurrentes con la misma tarjeta.
              </n-checkbox>
            </div>

            <!-- Botón pago -->
            <n-button
              v-if="formularioValido"
              type="info" size="lg"
              style="border: 2px solid #FF6600 !important;"
              @click.native="procesarPago">
              Pago Seguro Redsys
            </n-button>
            <n-button v-else
              type="info" size="lg"
              :disabled="true"
              style="border: 2px solid #FF6600 !important; cursor: default; opacity: 1;">
              Pago Seguro Redsys
              <el-tooltip content="Completa todos los campos obligatorios y acepta los términos" placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </n-button>

          </div>

        </div>
      </div>
    </div>

    <!-- Modal campos incompletos -->
    <modal :show.sync="modalFaltaCampos" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">Datos incompletos</h4>
      <p>Rellena todos los campos obligatorios (*) antes de continuar.</p>
      <template slot="footer">
        <n-button type="primary" @click.native="modalFaltaCampos = false">Entendido</n-button>
      </template>
    </modal>

    <!-- Modal acepta términos -->
    <modal :show.sync="modalAceptaTerminos" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">Acepta los términos</h4>
      <p>Debes aceptar los términos del contrato y la Política de Privacidad para continuar.</p>
      <template slot="footer">
        <n-button type="primary" @click.native="modalAceptaTerminos = false">Entendido</n-button>
      </template>
    </modal>

  </div>
</template>

<script>
import { Card, Button, FormGroupInput, Modal, Checkbox } from '@/components'
import { Select, Option, Tooltip, Notification } from 'element-ui'
import { RUTA_PHP } from '@/constants'
import axios from 'axios'

export default {
  name: 'contratar-sms',
  bodyClass: 'blog-post',

  components: {
    Modal,
    Card,
    [Button.name]:         Button,
    [Checkbox.name]:       Checkbox,
    [Select.name]:         Select,
    [Option.name]:         Option,
    [Tooltip.name]:        Tooltip,
    [FormGroupInput.name]: FormGroupInput,
  },

  // Igual que Pagos.vue — datos llega como prop desde el router
  props: {
    datos: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      // Params descifrados
      centroid: '',
      boxId:    '',
      promoId:  '',

      // Estado de carga
      datosCargados: false,
      precioCargado: false,
      errorCarga:    false,

      // Modales
      modalFaltaCampos:    false,
      modalAceptaTerminos: false,

      // Checkboxes
      autorizo:     false,
      pagorec:      false,
      pagopasarela: true,

      // Config del store
      logo_altura:  0,
      tipopasarela: 'redsys',

      // Datos de precio (de dameboxprecio.php)
      pvp_web:         '',
      pvp_men:         '',
      imp_dep:         '',
      pvp_con_iva:     '',
      fch_dsd_web:     '',
      fch_hst_web:     '',
      fch_pro_pag_web: '',
      id_unico:        '',

      // Fecha de inicio (del servidor)
      fechaInicio: '',

      // Formulario del contrato
      contrato: {
        nombre:    '',
        apellido1: '',
        apellido2: '',
        nif:       '',
        telefono:  '',
        email:     '',
        direccion: '',
        cp:        '',
        localidad: '',
        provincia: '',
        box:       '',
        ref:       '',
        precio:    '',
        deposito:  '',
        origen:    'SMS_LINK',
      },

      paisElegido: 'ES',

      errores: {
        nombre:    '* Requerido',
        apellido1: '* Requerido',
        nif:       '* Requerido',
        telefono:  '',
        email:     '* Requerido',
        direccion: '* Requerido',
        cp:        '* Requerido',
        localidad: '* Requerido',
      },
    }
  },

  computed: {
    formularioValido() {
      if (!this.autorizo)      return false
      if (!this.datosCargados) return false
      if (!this.precioCargado) return false
      const camposOk = this.contrato.nombre
        && this.contrato.apellido1
        && this.contrato.nif
        && this.contrato.email
        && this.contrato.direccion
        && this.contrato.cp
        && this.contrato.localidad
      if (!camposOk) return false
      return Object.values(this.errores).every(e => !e)
    }
  },

  methods: {

    // ── Validación campo a campo ─────────────────────────────────────────────
    valida(campo) {
      const v = (this.contrato[campo] || '').trim()
      const requeridos = ['nombre', 'apellido1', 'nif', 'email', 'direccion', 'cp', 'localidad']
      if (requeridos.includes(campo)) {
        this.errores[campo] = v.length > 0 ? '' : '* Requerido'
      }
      if (campo === 'email' && v.length > 0) {
        this.errores.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? '' : 'Email no válido'
      }
    },

    // ── Helpers de fecha ─────────────────────────────────────────────────────
    formatDate(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },

    formatearFechaParam(fecha) {
      if (typeof fecha === 'string') fecha = new Date(fecha)
      const y = fecha.getUTCFullYear()
      const m = String(fecha.getMonth() + 1).padStart(2, '0')
      const d = String(fecha.getDate()).padStart(2, '0')
      return `${y}${m}${d}`
    },

    // ── Paso 1: descifrar params del enlace SMS ──────────────────────────────
    leeDatos() {
      if (!this.datos) {
        console.error('ERROR: prop datos vacía')
        this.errorCarga = true
        return
      }
      console.log('datos prop:', this.datos)

      const params = new URLSearchParams()
      params.append('datos', this.datos)

      axios.post(RUTA_PHP + 'bridge-ai-transacContratarSMSDec.php', params)
        .then(response => {
          console.log('bridge-ai-transacContratarSMSDec raw:', response.data)
          const d = typeof response.data === 'string'
            ? JSON.parse(response.data)
            : response.data

          if (!d || d.resp === 'KO') {
            this.errorCarga = true
            return
          }

          console.log('bridge-ai-transacContratarSMSDec.php:', d)

          // Guardar IDs para las llamadas posteriores
          this.centroid = String(d.CENTRO || '')
          this.boxId    = String(d.BOX    || '')
          this.promoId  = String(d.PROMO  || '')

          // Pre-rellenar formulario con lo que ya sabe la IA
          this.contrato.nombre   = d.NOMBRE   || ''
          this.contrato.apellido1 = d.APELLIDO1 || ''
          this.contrato.apellido2 = d.APELLIDO2 || ''
          this.contrato.telefono = d.TELEFONO || ''
          this.contrato.box      = String(d.BOX || '')
          this.contrato.ref      = d.REF      || ''

          // Limpiar errores de campos pre-rellenados
          if (this.contrato.nombre)   this.errores.nombre   = ''
          if (this.contrato.apellido1) this.errores.apellido1 = ''
          if (this.contrato.telefono) this.errores.telefono = ''

          this.datosCargados = true

          // Paso 2: cargar precio
          this.cargarPrecio()
        })
        .catch(err => {
          console.error('Error en transacContratarSMSDec:', err)
          this.errorCarga = true
        })
    },

    // ── Paso 2: obtener precio del box ───────────────────────────────────────
    cargarPrecio() {
        console.log('cargarPrecio — centroid:', this.centroid, 'boxId:', this.boxId, 'promoId:', this.promoId, 'fecha:', this.fechaInicio)
        if (!this.centroid || !this.boxId || !this.promoId || !this.fechaInicio) {
          console.error('cargarPrecio: faltan parámetros')
          this.errorCarga = true
          return
        }

        const params = new URLSearchParams()
        params.append('centro', this.centroid)
        params.append('fecha',  this.formatearFechaParam(this.fechaInicio))
        params.append('idbox',  this.boxId)
        params.append('tiempo', this.promoId)

        axios.post(RUTA_PHP + 'dameboxprecio.php', params)
            .then(response => {
              console.log('dameboxprecio raw completo:', JSON.stringify(response.data))
              var pago = null
              if (response && response.data && response.data[0] &&
                  response.data[0].PAGO && response.data[0].PAGO[0]) {
                  pago = response.data[0].PAGO[0]
              }
              if (!pago) { this.errorCarga = true; return }

              this.pvp_web         = String(pago.PVP_WEB               || '0').replace('.', ',')
              this.pvp_men         = String(pago.PVP_MEN               || '0').replace('.', ',')
              this.imp_dep         = String(pago.DEP_WEB               || '0').replace('.', ',')
              this.pvp_con_iva     = String(pago.PVP_CON_IVA_PROX_WEB  || '0').replace('.', ',')
              this.id_unico        = String(pago.IDUNI                  || '')
              this.fch_dsd_web     = String(pago.FCH_DSD_WEB            || '').split('-').reverse().join('/')
              this.fch_hst_web     = String(pago.FCH_HST_WEB            || '').split('-').reverse().join('/')
              this.fch_pro_pag_web = String(pago.FCH_PRO_PAG_WEB        || '').split('-').reverse().join('/')

              this.contrato.precio   = String(pago.PVP_WEB || '0')
              this.contrato.deposito = String(pago.DEP_WEB || '0')

              this.precioCargado = true
            })
            .catch(err => {
              console.error('Error en dameboxprecio:', err)
              this.errorCarga = true
            })
    },

    // ── Helpers para el pedido Redsys ────────────────────────────────────────
    getId() {
      return (Math.floor(new Date().getTime() / 1000) - 1546300800).toString(36)
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min
    },

    // ── Paso 3: procesar pago Redsys ─────────────────────────────────────────
    async procesarPago() {
      if (!this.autorizo)         { this.modalAceptaTerminos = true; return }
      if (!this.formularioValido) { this.modalFaltaCampos    = true; return }

      const precstr = this.pvp_web.replace(',', '')

      const oRef = {
        CENTRO:    this.centroid,
        NOMBRE:    this.contrato.nombre,
        APELLIDO1: this.contrato.apellido1,
        APELLIDO2: this.contrato.apellido2,
        TELEFONO:  this.contrato.telefono,
        EMAIL:     this.contrato.email,
        CP:        this.contrato.cp,
        NIF:       this.contrato.nif,
        DIRECCION: this.contrato.direccion,
        LOCALIDAD: this.contrato.localidad,
        PROVINCIA: this.contrato.provincia,
        IBAN:      '',
        ENTIDAD:   '',
        OFICINA:   '',
        DC:        '',
        CUENTA:    '',
        BOX:       this.contrato.box,
        REF:       this.contrato.ref,
        IDUNICO:   this.id_unico,
        PRECIO:    this.pvp_web.replace(',', '.'),
        DEPOSITO:  this.imp_dep.replace(',', '.'),
        MOTIVO:    '',
        FUENTE:    'SMS_LINK',
        ORIGEN:    'SMS_LINK',
        FINICIO:   this.fechaInicio,
        FP:        1,
        PAIS:      this.paisElegido,
      }

      const merData     = JSON.stringify(oRef)
      const ord2        = this.getRandomInt(100, 999).toString(36) + this.getId()
      const phpEndpoint = this.pagorec
        ? 'pasarela_contrato_autoriz.php'
        : 'pasarela_contrato.php'

      const params = new URLSearchParams()
      params.append('order',   ord2)
      params.append('importe', precstr)
      params.append('merdata', merData)
      params.append('centro',  this.centroid)
      params.append('usuario', '')
      params.append('dni1',    '')
      params.append('dni2',    '')
      params.append('email',   this.contrato.email)

      try {
        const respuesta = await axios.post(RUTA_PHP + phpEndpoint, params)

        if (respuesta.data.params === 'KO') {
          Notification.error({
            title:    'Error',
            message:  'No se pudo procesar el pago. Inténtalo de nuevo.',
            duration: 0,
          })
          return
        }

        // Construir y enviar formulario a Redsys
        const mapForm  = document.createElement('form')
        mapForm.target = '_self'
        mapForm.method = 'POST'
        mapForm.action = this.$store.state.ruta_pasarela_banco

        const addInput = (name, value) => {
          const i = document.createElement('input')
          i.type = 'hidden'; i.name = name; i.value = value
          mapForm.appendChild(i)
        }
        addInput('Ds_SignatureVersion',   'HMAC_SHA256_V1')
        addInput('Ds_MerchantParameters', respuesta.data.params)
        addInput('Ds_Signature',          respuesta.data.signature)

        document.body.appendChild(mapForm)
        mapForm.submit()

      } catch (err) {
        console.error('Error pasarela:', err)
        Notification.error({
          title:    'Error de conexión',
          message:  'No se pudo conectar con la pasarela de pago. Inténtalo de nuevo.',
          duration: 5000,
        })
      }
    },
  },

  mounted() {
    console.log('route.query completo:', JSON.stringify(this.$route.query))
    console.log('datos prop:', this.datos)

    this.logo_altura  = this.$store.state.logo_altura
    this.tipopasarela = this.$store.state.tipo_pasarela || 'redsys'
    this.pagopasarela = this.$store.state.pago_pasarela

    // Obtener fecha del servidor → arrancar cadena de carga
    axios.get(RUTA_PHP + 'damefecha.php')
      .then(r => {
        this.fechaInicio = this.formatDate(new Date(r.data))
        this.leeDatos()
      })
      .catch(() => {
        this.fechaInicio = this.formatDate(new Date())
        this.leeDatos()
      })
  },
}
</script>

<style scoped>
.page-head2 {
  background-color: #0045c4;
  padding: 0;
  margin-bottom: 0;
}
</style>